module.exports = {
  
  // this takes a string and returns an array of words
  filter: (toFilter) => {
    
    toFilter = toFilter.toLowerCase();
    toFilter = toFilter.replace(/[^a-z ]/g, "");
    toFilter = toFilter.split(" ");
    
    let out = [];
    for (let i in toFilter) {
      if ( toFilter[i] == "" || words.includes(toFilter[i]) == true ) continue;
      out.push(toFilter[i]);
    }
    
    return out;
  },
  
  
  // filters what a user would use for a keywords search
  keywords: (arrayToFilter) => {
    
    let out = [];
    
    for (let i in arrayToFilter) {
      let atf = arrayToFilter[i];
      atf = atf.toLowerCase();
      atf = atf.replace(/[^a-z0-9 ]/g, "");
      if ( atf == "" || words.includes(atf) == true ) continue;
      out.push(atf);
    }
    
    return out;
  },
  
  
  // we remove standard components, such as blvd, st, etc...
  address: (toFilter) => {
    
    toFilter = toFilter.toLowerCase();
    toFilter = toFilter.replace(/[^a-z0-9 ]/g, "");
    toFilter = toFilter.split(" ");
    
    let out = [];
    for (let i in toFilter) {
      if ( toFilter[i] == "" || addressParts.includes(toFilter[i]) == true ) continue;
      out.push(toFilter[i]);
    }
    
    return out;
  },
  
  
  // we remove symbols
  price: (toFilter, currency) => {
    
    toFilter = toFilter.toLowerCase();
    const re = new RegExp(`[^a-z0-9 \\${currency}]`);
    toFilter = toFilter.replace(re, "");
    toFilter = toFilter.split(" ");
    
    let out = [];
    for (let i in toFilter) {
      if ( toFilter[i] == "" || words.includes(toFilter[i]) == true ) continue;
      out.push(toFilter[i]);
    }
    
    return out;
  },
  
  
  // takes an already created array of words and removes any duplicates
  removeDuplicates: (toFilter) => {
    return [...new Set(toFilter)];
  },
  
  
}


// words that we want to filter out
let words = [
  "a", "all", "also", "am", "and", "at", "basically", "been", "come", "did", "does", "down", "etc", "for", "from", "get", "going", "got", "had", "has", "i", "if", "in", "inevitably", "is", "it", "ive", "later", "new", "not", "of", "over", "previous", "some", "the", "them", "those", "through", "to", "us", "via", "weve", "with", "you", "your", "youre",
];


let addressParts = [
  "blvd", "dr", "st", "cir", "ct", "ave", "street", "boulivard", "circle", "avenue", "court", "drive"
];

// alphabitize words
// words.sort(function (a,b) {
//   return a.localeCompare(b);
// });

// let out = "";
// for (let i in words) {
//   out += `"${words[i]}", `;
// }

// console.log("alpha words:", out);


// console.log("filter:", module.exports.filter("I've got a good idea for some, new soup") );
// console.log("address:", module.exports.address("1234 main st, los angeles, ca, 91000") );

// console.log("removeDuplicates:", module.exports.removeDuplicates( module.exports.filter("I've got a good idea for some, new soup soup soup") ) );
